import { render } from "./SmsManagement.vue?vue&type=template&id=0e474aff&scoped=true"
import script from "./SmsManagement.vue?vue&type=script&lang=js"
export * from "./SmsManagement.vue?vue&type=script&lang=js"

import "./SmsManagement.vue?vue&type=style&index=0&id=0e474aff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e474aff"]])

export default __exports__